import React, { Component } from 'react';
import Modal from './Modal';
import check from "../../assets/check.svg";
import info from "../../assets/Info.png";
import equis from "../../assets/eliminar.svg"
import ComponenteContrasenia from './ComponenteContrasenia';
import '../../css/FormCambiarContrasenia.css';
import axios from 'axios';
import Cookies from 'js-cookie';
import Header from '../components/Header.js'
import Footer from '../components/Footer.js'
import CenteredWrapper from '../components/CenteredWrapper.js';
import BotonExpandible from "../components/BotonExpandible";
import anuncioico from "../../assets/AnuncioICO.svg";
import jwt from 'jwt-decode'
import { Spinner } from 'react-bootstrap';
import { ComponenteSpinner } from '../adminComponents/ComponenteSpinner';
import MenuUsuario from './MenuUsuario';

export class FormCambiarContrasenia extends Component {

  

    constructor(props){
        super(props);

        this.state = {
            nombresRegla:"",
            modalIsOpen:false,
            verBoton:true,
            isCcex: false,
            datosUsuario:{
                token: "",
                id: "",
                nombres: "",
                apellidos: "",
                username: "",
                correo: "",
            },
            contra:{
              contrasena: "",
              contrasenaactual: "",
                contrasenaCumple:false,
                repetirContraCumple:false,
            },
            expresiones:{
                contrasena:/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@*._-]{10,12}$/,
            },
            navigateCas:true,
            modalError: {
                show: false,
                titulo: "",
                mensaje: "",
                imagen : ""
          },
          modalErrorQuit: {
            show: false,
            titulo: "",
            mensaje: "",
            imagen: ""
          },
            activebutton: true,
            isUpdateePss:true,
            token_nueva_cuenta: "",
            token_entraID: sessionStorage.getItem("access_token"),
        };

        this.abrirModalInfo=this.abrirModalInfo.bind(this);
        this.cerrarModalInfo=this.cerrarModalInfo.bind(this);
        this.cambiarEstado=this.cambiarEstado.bind(this)
        this.abrirModalError=this.abrirModalError.bind(this);
        this.cerrarModalError = this.cerrarModalError.bind(this);
        this.cerrarModalErrorQuit = this.cerrarModalErrorQuit.bind(this);
    }


    abrirModalError() {
        this.setState({
            modalError: {
                ...this.state.modalError,
                show: true
            }
        });
    }

    cerrarModalError() {
        this.setState({
            modalError: {
                titulo: "",
                mensaje: "",
                imagen: "",
                show: false
            }
        });
    }

    cerrarModalErrorQuit() {
        this.setState({
            modalErrorQuit: {
                titulo: "",
                mensaje: "",
                imagen: "",
                show: false
            }
        }, () => {
            //cerrrar seción y matar cookies
            Cookies.remove("nombres");
            Cookies.remove("apellidos");
            Cookies.remove("identificacion");
            Cookies.remove("token");
            Cookies.remove("rol");
            Cookies.remove("username");
            Cookies.remove("DatosPersonalesGIA.CAS");
            Cookies.remove("id");
            Cookies.remove("correoAlterno");
            Cookies.remove("Nombre");
            window.location.href = "/logout";
        });
    }

    abrirModalInfo(){
        this.setState({modalIsOpen:true});
    }

    cerrarModalInfo(){
        this.setState({ modalIsOpen: false });
        this.activarNavigateLogin();
    }

    activarNavigateLogin() {
        window.location.href = "/Inicio";

    }
    
    cambiarEstado(contraActual,valor,contraCumple,repetirContraCumple){
        this.setState({
            contra:{
                ...this.state.contra,
              contrasena: valor,
              contrasenaactual: contraActual,
              contrasenaCumple:contraCumple,
              repetirContraCumple:repetirContraCumple
            }
        })
    }

    agregarNombresEnRegla() {
        var nombreString = "";
        var nombres = this.state.datosUsuario.nombres.split(" ");
        // var nombres_temp = nombres.split(" ");
        var apellidos = this.state.datosUsuario.apellidos.split(" ");
        // var apellidos_temp = apellidos.split(" ");

        var nombreCompleto = nombres.concat(apellidos);

        for (var i = 0; i < nombreCompleto.length; i++) {
            if (i == nombreCompleto.length - 1) {
                nombreString = nombreString.concat(nombreCompleto[i]);
            } else {
                nombreString = nombreString.concat(nombreCompleto[i] + ", ");
            }
        }
        this.setState({
            nombresRegla: nombreString
        })
    }


    obtenerTokenCuentaNueva  = async () => {
        const username = this.state.datosUsuario.username;
        if (username !== "") {
            try {
                const r = await axios.get(`${process.env.REACT_APP_API}api/CuentaUsuario/tokennuevacuenta/${username}`, {
                    headers: {
                        Authorization: `Bearer ${this.state.token_entraID}`
                    }
                });

                if (r.status === 200) {
                    this.setState({
                        token_nueva_cuenta:r.data.token,
                        //navigateCas: false
                    })
                }
            } catch (error) {
                console.error(error);
            }
        }
    };
    
    validarCAS () {
        var ruta = window.location.href;
        if (ruta.split("token=")[1] != undefined) { /* CASO EN DONDE SE INGRESA CON TOKEN ENVIADO AL CORREO */
            var token = ruta.split("token=")[1];

             this.setState({
                token_nueva_cuenta: token
            })


            this.state.datosUsuario.token = token;
            this.state.isUpdateePss = false;
            var tokendecode = jwt(token);

            var exp = tokendecode["exp"];
            this.state.datosUsuario.nombres = tokendecode["Nombres"];
            this.state.datosUsuario.apellidos = tokendecode["Apellidos"];
            this.agregarNombresEnRegla();
            this.state.datosUsuario.username = tokendecode["User"];
            var fe1 = new Date(exp * 1000);
            var fe2 = new Date();

            if (fe1 < fe2) {
                window.location.href = "/Inicio";
            } else {
                this.setState({ navigateCas: false })
            }
        } else {    /* CASO EN DONDE SE INGRESA LOGEADO CON EL ENTRA ID */
            var token = Cookies.get("token");
             /*this.setState({
                token_nueva_cuenta: token
            }) */  
            if(token != undefined){
                
                var tokendecode = jwt(token);
                var exp = tokendecode["exp"];
                this.setState(prev => ({
                    datosUsuario: {
                        ...prev.datosUsuario,
                        token: token,
                        nombres: tokendecode["Nombres"],
                        apellidos: tokendecode["Apellidos"],
                        username: tokendecode["User"]
                    }
                }),async ()=>{
                   await this.obtenerTokenCuentaNueva();
                    this.setState({ navigateCas: false});
                });
                /*this.state.datosUsuario.token = token;
                this.state.datosUsuario.nombres = tokendecode["Nombres"];
                this.state.datosUsuario.apellidos = tokendecode["Apellidos"];
                this.state.datosUsuario.username = tokendecode["User"];*/

                this.agregarNombresEnRegla();
            }else{
               this.setState({
                    modalErrorQuit: {
                    show: true,
                    imagen: equis,
                    titulo: "Error validando el inicio de sesión",
                    mensaje: "Por favor, vuelva a intentarlo."
                    }
                });
            }
        }   
        return (null)
    };


    /*componentWillMount() {
        this.useEffect();
        this.validarCAS();        
    }*/
    async componentDidMount() {
        this.validarCAS();
    }


    useEffect = () => {
        /*const loadScriptByURL = (id, url, callback) => {
            const isScriptExist = document.getElementById(id);

            if (!isScriptExist) {
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src = url;
                script.id = id;
                script.onload = function () {
                    if (callback) callback();
                };
                document.body.appendChild(script);
            }
            if (isScriptExist && callback) callback();
        }
        loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_CAPTCHAKEY}`, function () {
        });*/
    };

    postCambioContraApiExt = async (data) => {
        try {
            const resp = await axios.post(`${process.env.REACT_APP_API_EXT}/Account/CambiarContrasenia`, data);

            if (resp.data?.status?.isSuccessfully) {
                this.abrirModalInfo();
            } else {
                let messageOlvidoContrasenia = resp.data.status.messages[0];

                if (typeof messageOlvidoContrasenia === 'string' && messageOlvidoContrasenia !== null) {
                    if (messageOlvidoContrasenia.includes("No existe una cuenta externa creada con ese correo electrónico")) {
                        this.setState({
                            modalError: {
                                show: true,
                                titulo: "ATENCIÓN",
                                mensaje: (
                                    <span className='olvContra-mdl-text' align="justify">
                                    No existe una cuenta externa creada con ese correo electrónico, ingrese aquí para registrarse:{" "}
                                    <a href="/registro"><i>Crear Cuenta</i></a>
                                    </span>
                                ),
                                imagen: info,
                            }
                        });
                    } else if (messageOlvidoContrasenia.includes("")) {
                        this.setState({
                                modalError: {
                                show: true,
                                titulo: "Error",
                                mensaje: "",
                                imagen: info,
                            }
                        });
                    } else {
                        this.setState({
                            modalError: {
                                show: true,
                                titulo: "Error",
                                mensaje: messageOlvidoContrasenia,
                                imagen: equis,
                            }
                        });
                    }
                } else {
                    this.setState({
                        modalError: {
                            show: true,
                            titulo: "Error",
                            mensaje: "Lo sentimos, tuvimos un problema.",
                            imagen: equis,
                        }
                    });
                }
            }
            this.setState({ activebutton: true });
        } catch (error) {
            this.setState({
            modalError: {
                show: true,
                titulo: "Error",
                mensaje: "Lo sentimos, vuelva a intentar.",
                imagen: equis,
            }
            });
            this.setState({ activebutton: true });
        }
    };

    postCambiarContrasena = async () => {
        this.props.callTagManager("click-btn-guardar-cambiar-contrasena");
        this.setState({ activebutton: false });
        const { isCcex } = this.state;

        if (isCcex) {
            var credenciales = { 
                password: this.state.contra.contrasena,                
                email: this.state.datosUsuario.username, 
            };

            await this.postCambioContraApiExt(credenciales);
        } else {
            var tipoDeCambio = ""; //Actualizar o Restaurar
            if (this.state.isUpdateePss) {
                tipoDeCambio = "Actualizar"
            } else {
                tipoDeCambio = "Restaurar"
            }
            
            //Por ahora sera siempre restaurar
            tipoDeCambio = "Restaurar";

            var cambiarContra = {
                password: this.state.contra.contrasena,
                passwordActual: this.state.contra.contrasenaactual,
                correo: this.state.datosUsuario.correo,
                token: this.state.datosUsuario.token,
                tipoCambio: tipoDeCambio
            }
            axios.post(`${process.env.REACT_APP_API}api/CuentaUsuario/change`, cambiarContra, {
                headers: {
                    Authorization: `Bearer ${this.state.token_nueva_cuenta}`
                }
            })
            .then(resp => {
                if (resp.status === 200) {
                    if (resp.data.message === "Contraseña cambia exitosamente") {
                        this.abrirModalInfo();
                    }
                }
                this.setState({ activebutton: true });
            }).catch(error => {
                if (error.response && error.response.status === 401) {
                    this.setState({
                        modalError: {
                        show: true,
                        titulo: "Error con validación del token",
                        mensaje: "El token EntraID del usuario ha expirado. Por favor comience el proceso nuevamente.",
                        imagen: equis,
                        }
                    });
                } else if (error.request.response === "" || error.request.response === " ") {
                    this.setState({
                        modalErrorQuit: {
                            show: true,
                            imagen: equis,
                            titulo: "No puede realizar esta acción",
                            mensaje: error.response.data.errorMessage
                        }
                    })
                } else if (error.response.data.errorMessage === "La sesión expiró, vuelva a intentarlo.") {
                    this.setState({
                        modalErrorQuit: {
                            show: true,
                            imagen: equis,
                            titulo: "No puede realizar esta acción",
                            mensaje: error.response.data.errorMessage
                        }
                    })
                } else {
                    this.setState({
                        modalError: {
                            show: true,
                            imagen: equis,
                            titulo: "Error en la solicitud",
                            mensaje: error.response.data.errorMessage
                        }
                    })
                }
                this.setState({ activebutton: true });
            });
        }        
    }   

   
    render() {
        var nombresCompletos = `${this.state.datosUsuario.nombres} ${this.state.datosUsuario.apellidos}`
        var username = `${this.state.datosUsuario.username}`
        if (this.state.navigateCas) {
              return (
                    <div style={{ textAlign:'center', marginTop:'100px' }}>
                        <ComponenteSpinner></ComponenteSpinner>
                    </div>
                );
        }
        return (
                <div >
                    <MenuUsuario
                        mostrarNombre={true}
                        nombresCompletos={`${this.state.datosUsuario.nombres} ${this.state.datosUsuario.apellidos}`}
                    />

                    <Header />
                    <CenteredWrapper>
                        <div className="formCambCont-container">
                            
                            <div className="row">
                                <BotonExpandible 
                                    mensaje={
                                    <div className=" col-xl-12 ">
                                        <p className="text-justify-center">
                                            <b>REGLAS QUE DEBE CUMPLIR LA CONTRASEÑA:</b>
                                        </p>
                                        <ul>
                                            <li>Tener mínimo 10 caracteres y máximo 12.</li>
                                            <li>Tener al menos una letra minúscula.</li>
                                            <li>Tener al menos una letra mayúscula.</li>
                                            <li>Tener al menos un número.</li>
                                            <li>Solo permite lo siguientes caracteres especiales: @ , * , . , _ , - </li>
                                            <li>La contraseña no puede ser similar al usuario: {username.split("@")[0]}. </li>
                                            <li>La contraseña no puede contener las siguientes palabras: {this.state.nombresRegla }.</li>

                                        </ul>
                                    </div>
                                    }
                                />
                                {/* <div className=" col-sm-2 col-xl-2"></div>
                                <div id="registroContra-reglas" className="col-sm-8 col-xl-8">
                                    <div className="row registroContra-padding">
                                        <div className=" col-xl-12 ">
                                            <p className="text-justify-center">
                                                <b>REGLAS QUE DEBE CUMPLIR LA CONTRASEÑA:</b>
                                            </p>
                                            <ul>
                                                <li>Tener mínimo 10 caracteres y máximo 12.</li>
                                                <li>Tener al menos una letra minúscula.</li>
                                                <li>Tener al menos una letra mayúscula.</li>
                                                <li>Tener al menos un número.</li>
                                                <li>Solo permite lo siguientes caracteres especiales: @ , * , . , _ , - </li>
                                                <li>La contraseña no puede ser similar al usuario: {username.split("@")[0]}. </li>
                                                <li>La contraseña no puede contener las siguientes palabras: {this.state.nombresRegla }.</li>

                                            </ul>
                                        </div>
                                    </div>
                                </div> */}
                            </div>

                            <div className="row" >
                                <div className=" col-sm-2 col-xl-2"></div>
                                <div className="col-sm-8 col-xl-8 title_cambio_contra">
                                    <div >
                                        <p className="formCambCont-title"><b>CAMBIO DE CONTRASEÑA</b></p>
                                    </div>
                                    {/* <div >
                                        <p align="justify"> Hola <b>{nombresCompletos}</b>: </p>
                                    </div> */}
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-2">
                                </div>
                                <div className="col-lg-8  mt-4">
                                                                    
                                    <ComponenteContrasenia
                                    columnas="col-md-8 col-xl-6"
                                    cambiarEstado={this.cambiarEstado}
                                    expresionRegular={this.state.expresiones.contrasena}
                                    nombres={this.state.datosUsuario.nombres}
                                    apellidos={this.state.datosUsuario.apellidos}
                                    usuario={this.state.datosUsuario.username}
                                    isUpdateePss={this.state.isUpdateePss}
                                    >
                                    </ComponenteContrasenia>
                                    <div className="formCambCont-btn-guardar" align="center">
                                        <button
                                            type="button"
                                            onClick={this.postCambiarContrasena}
                                            disabled={this.state.contra.contrasena &&this.state.contra.contrasena &&
                                                this.state.contra.contrasenaCumple &&
                                                this.state.contra.repetirContraCumple && this.state.activebutton ? false : true}
                                            className={this.state.contra.contrasena &&
                                                this.state.contra.contrasenaCumple &&
                                                this.state.contra.repetirContraCumple && this.state.activebutton ?
                                                "formCambCont-btn-submit" : "formCambCont-btn-submit-disabled"}
                                        >GUARDAR</button>
                                        {!this.state.activebutton ?

                                            <span className="registroContra-fr-top spinner-border text-primary ms-2" role="status" aria-hidden="true"></span>
                                        
                                            : null}
                                    </div>
                                {/*    <div ><button onClick={this.activarNavigateLogin}> OBTENER TOKEN</button></div>*/}
                                </div>                      
                            </div>
                
                        </div>
                    </CenteredWrapper>
                   <Footer/>         
        
                {this.state.modalIsOpen&& 
                    <Modal isOpen={this.state.modalIsOpen} cerrarModal={this.cerrarModalInfo} verBoton={this.state.verBoton} textoBoton="ACEPTAR" >
                        <p className='text-center'><strong>Contraseña cambiada exitosamente</strong></p>
                        <div className='mt-6 mb-6' align="center">
                            <img className="check" src={check} alt="Exitoso"></img>
                        </div>

                        <p className='text-center'><strong>¡Gracias por finalizar el formulario!</strong></p>
                        <p className='text-center'>Ahora puede iniciar sesión</p>
                        
                    </Modal>
                }

                {this.state.modalError.show &&
                        <Modal isOpen={this.state.modalError.show} cerrarModal={this.cerrarModalError} verBoton={true} textoBoton="ACEPTAR" >
                        <p className='text-center'><strong>{this.state.modalError.titulo}</strong></p>
                        <div className='mt-6 mb-6' align="center">
                            <img className="registroContra-check" src={this.state.modalError.imagen} alt="Exitoso"></img>
                        </div>

                        <p className='text-center'>{this.state.modalError.mensaje}</p>
                    </Modal>
                }
                {this.state.modalErrorQuit.show &&
                <Modal isOpen={this.state.modalErrorQuit.show} cerrarModal={this.cerrarModalErrorQuit} verBoton={true} textoBoton="ACEPTAR" >
                  <p className='text-center'><strong>{this.state.modalErrorQuit.titulo}</strong></p>
                    <div className='mt-6 mb-6' align="center">
                    <img className="registroContra-check" src={this.state.modalErrorQuit.imagen} alt="Exitoso"></img>
                    </div>

                  <p className='text-center'>{this.state.modalErrorQuit.mensaje}</p>
                  </Modal>
                }


            </div>
            
        )
    }
}

export default FormCambiarContrasenia
